import styled from 'styled-components';

interface ITagProps {
  display?: string;
}

export const Tag = styled.div`
  display: ${(props: ITagProps) => (props.display ? props.display : 'block')};
`;
